export default "/images/0a606629ec467c9b4fae1de8228e7126.avif";